import swift from './images/vehicleimagesdata/swiftdzire.jpg'
import verna from './images/vehicleimagesdata/verna.jpg'
import i20 from './images/vehicleimagesdata/i20.jpg'
import baleno from './images/vehicleimagesdata/baleno.jpg'
import spender from './images/vehicleimagesdata/splender.jpg'
import ktm from './images/vehicleimagesdata/ktm.jpeg'
import bullett from './images/vehicleimagesdata/bullett.jpg'
import apache from './images/vehicleimagesdata/apache.jpg'

export const vehicledata = [
  {
    id: 1,
    type: 'car',
    vehiclename: 'Swift Dezire',
    vehicleimage: swift,
    rating: 4,
    tripnumber: 10,
    transmissiontype: 'manual',
    powertype: 'petrol',
    seats: 4,
    price: 400,
    city: 'Mumbai',
  },
  {
    id: 2,
    type: 'car',
    vehiclename: 'Verna',
    vehicleimage: verna,
    rating: 4.7,
    tripnumber: 5,
    transmissiontype: 'cvt',
    powertype: 'diesel',
    seats: 4,
    price: 470,
    city: 'Delhi',
  },
  {
    id: 3,
    type: 'car',
    vehiclename: 'I20 Sports',
    vehicleimage: i20,
    rating: 3.7,
    tripnumber: 18,
    transmissiontype: 'amt',
    powertype: 'petrol',
    seats: 4,
    price: 350,
    city: 'Bangalore',
  },
  {
    id: 4,
    type: 'car',
    vehiclename: 'Baleno',
    vehicleimage: baleno,
    rating: 3.8,
    tripnumber: 23,
    transmissiontype: 'manual',
    powertype: 'electric',
    seats: 4,
    price: 320,
    city: 'Hyderabad',
  },
  {
    id: 5,
    type: 'bike',
    vehiclename: 'Splendor',
    vehicleimage: spender,
    rating: 3.2,
    tripnumber: 25,
    transmissiontype: 'manual',
    powertype: 'petrol',
    seats: 2,
    price: 110,
    city: 'Mumbai',
  },
  {
    id: 6,
    type: 'bike',
    vehiclename: 'KTM',
    vehicleimage: ktm,
    rating: 4.1,
    tripnumber: 5,
    transmissiontype: 'manual',
    powertype: 'petrol',
    seats: 2,
    price: 200,
    city: 'Delhi',
  },
  {
    id: 7,
    type: 'bike',
    vehiclename: 'Bullett 350 Classic',
    vehicleimage: bullett,
    rating: 4.6,
    tripnumber: 15,
    transmissiontype: 'manual',
    powertype: 'petrol',
    seats: 2,
    price: 250,
    city: 'Bangalore',
  },
  {
    id: 8,
    type: 'bike',
    vehiclename: 'Apache 150 RTR',
    vehicleimage: apache,
    rating: 3.7,
    tripnumber: 20,
    transmissiontype: 'manual',
    powertype: 'petrol',
    seats: 2,
    price: 220,
    city: 'Hyderabad',
  },
]
